/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ModelHierarchy } from '../../models/model-hierarchy';
import { UpdateModelCommand } from '../../models/update-model-command';

export interface ApiAdminModelsModelIdPut$Params {
  modelId: string;
      body?: UpdateModelCommand
}

export function apiAdminModelsModelIdPut(http: HttpClient, rootUrl: string, params: ApiAdminModelsModelIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelHierarchy>> {
  const rb = new RequestBuilder(rootUrl, apiAdminModelsModelIdPut.PATH, 'put');
  if (params) {
    rb.path('modelId', params.modelId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelHierarchy>;
    })
  );
}

apiAdminModelsModelIdPut.PATH = '/api/Admin/models/{modelId}';
